import { AlertTriangle } from "lucide-react"

import { DialogModal } from "@/components/shared/ui/dialog-modal"
import { Button, DialogDescription, DialogTitle } from "@/components/ui"

interface RestrictedAccountModalProps {
  open: boolean
  onContact: () => void
  onExit: () => void
}

export const RestrictedAccountModal = ({
  open,
  onContact,
  onExit
}: RestrictedAccountModalProps) => {
  const handleContact = () => {
    onContact()
  }

  const handleExit = () => {
    // Prevent exit - modal should stay open when account is restricted
    // Optionally could logout or do nothing
    onExit()
  }

  return (
    <DialogModal
      open={open}
      onClose={onExit}
      title={
        <>
          <div className="w-16 h-16 rounded-full bg-[#DC262633] flex items-center justify-center mb-3 mx-auto">
            <AlertTriangle className="w-8 h-8 text-[#DC2626]" />
          </div>

          {/* Title */}
          <DialogTitle className="text-xl font-bold text-gray-900 mb-3">
            Tài khoản của bạn bị khóa
          </DialogTitle>

          {/* Description */}
          <DialogDescription className="text-black text-sm leading-relaxed mb-3">
            Vui lòng liên hệ với ZZP để được hỗ trợ!
          </DialogDescription>
        </>
      }
      children={
        <div className="flex gap-3 mt-4">
          <Button
            variant="outline"
            className="flex-1 border-gray-300 text-gray-700 bg-white"
            onClick={handleExit}
          >
            Thoát
          </Button>
          <Button className="flex-1 text-white font-normal bg-[#DC2626]" onClick={handleContact}>
            Liên hệ ngay
          </Button>
        </div>
      }
    />
  )
}
